import React from "react";
import ContentArea from "../ContentArea/ContentArea";
import Layout from "./Layout/Layout";
import { useSeo } from "../../utils/Hooks/useSeo";
import "./GlossaryPage.css";

type GlossaryEntry = {
  term: string;
  definition: string;
};

const GLOSSARY_ENTRIES: GlossaryEntry[] = [
  {
    term: "Bitcoin",
    definition:
      "A digital money system with no central owner. Anyone can verify transactions using open-source rules.",
  },
  {
    term: "Blockchain",
    definition:
      "A public history of Bitcoin transactions grouped into blocks. Each new block links to the previous one.",
  },
  {
    term: "Block",
    definition:
      "A bundle of verified transactions added to the blockchain. On average, Bitcoin adds one about every 10 minutes.",
  },
  {
    term: "Proof of Work",
    definition:
      "The security process where miners spend computing power to create valid blocks. This makes rewriting history very expensive.",
  },
  {
    term: "Hash",
    definition:
      "A fixed-size fingerprint of data. Even a tiny data change creates a very different hash.",
  },
  {
    term: "Hashrate",
    definition:
      "The total computing power miners are using on Bitcoin. Higher hashrate generally means stronger network security.",
  },
  {
    term: "Difficulty",
    definition:
      "An automatic setting that controls how hard it is to mine a block. It adjusts so blocks stay near a 10-minute average.",
  },
  {
    term: "Halving",
    definition:
      "An event every 210,000 blocks where new bitcoin issued per block is cut in half.",
  },
  {
    term: "Block Subsidy",
    definition:
      "The newly created bitcoin paid to miners in each block. This amount decreases over time because of halvings.",
  },
  {
    term: "21 Million Supply Cap",
    definition:
      "Bitcoin is designed so total supply approaches, but never exceeds, 21 million BTC under current consensus rules.",
  },
  {
    term: "Satoshi (sat)",
    definition:
      "The smallest bitcoin unit. 1 BTC equals 100,000,000 satoshis.",
  },
  {
    term: "Wallet",
    definition:
      "Software or hardware that stores your keys and lets you send or receive bitcoin.",
  },
  {
    term: "Private Key",
    definition:
      "A secret number that proves ownership of bitcoin. Whoever controls it can spend those funds.",
  },
  {
    term: "Seed Phrase",
    definition:
      "A human-readable backup of wallet keys (usually 12 or 24 words). If lost, recovery is usually impossible.",
  },
  {
    term: "UTXO",
    definition:
      "Unspent Transaction Output. Bitcoin tracks spendable coins as discrete chunks, not account balances.",
  },
  {
    term: "Mempool",
    definition:
      "A waiting area for valid transactions before they are included in a mined block.",
  },
];

export const GlossaryPage = () => {
  useSeo({
    title: "Bitcoin Glossary",
    description:
      "Simple and accurate Bitcoin glossary with stable core terms like blockchain, hashrate, halving, sats, and UTXO.",
    canonicalPath: "/glossary",
  });

  return (
    <Layout>

      <ContentArea
      >
        <div className="glossary-table-wrap">
          <table className="glossary-table">
            <thead>
              <tr>
                <th>Term</th>
                <th>Simple explanation</th>
              </tr>
            </thead>
            <tbody>
              {GLOSSARY_ENTRIES.map((entry) => (
                <tr key={entry.term}>
                  <th scope="row">{entry.term}</th>
                  <td>{entry.definition}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ContentArea>
      <br />
    </Layout>
  );
};
